<div class="example-boundary">

  @if (!graphData) {
    @if (loadingGrafoLocal) {
      <div class="flex justify-content-center align-items-center h-screen">
        <p-progressSpinner strokeWidth="3"></p-progressSpinner>
      </div>
    } @else {
      <div class="flex justify-content-center pt-3">
        <p-message severity="info" class="w-8 lg:w-6" [closable]="false">
          <div class="flex align-items-center gap-2">
            <i class="mdi mdi-information-variant-circle mr-2 text-3xl"></i>
            <span>{{ 'ERRORE DATI...' }}</span>
          </div>
        </p-message>
      </div>
    }
  } @else {
    <div class="flex flex-column flex-wrap">
      @for (node of nodes; track node) {
        <div
            class="node-container animation-duration-300"
            [id]="node.id"
            [class.root-border]="node.isRadice"
            [class.border-grey]="!node.isRadice"
            [class.centered]="node.isRadice && !node.initCoordinates"
            [style.left]="node.initCoordinates.x + 'px'"
            [style.top]="node.initCoordinates.y + 'px'">
          <div class="flex flex-column">
            @if (node.isDeceduto) {
              <span class="badge-deceduto">
                <i class="mdi mdi-flower-tulip-outline"></i>
              </span>
            }
            @if (node.isDisabile) {
              <span class="badge-disabile">
                <i class="mdi mdi-wheelchair"></i>
              </span>
            }
            <div class="flex align-items-center gap-1 px-1">
              @if (node.eta && !node.isDeceduto) {
                <span class="badge-eta">{{ node.eta }}</span>
              }
              <p-avatar [image]="node.imgUrl" shape="circle" class="graph-card-img"></p-avatar>
              <div class="flex align-items-start" style="margin-left: 0.1rem">
                <span class="font-bold text-sm truncate-text">{{ node.nome }}</span>
              </div>
            </div>
            <div class="bg-toolbar-light node-bottom-toolbar flex flex-column align-items-start px-1 max-width-text-container">
              <span class="text-xs">{{ node.statoCivile }}</span>
              <span class="text-xs white-space-nowrap overflow-hidden text-overflow-ellipsis professione-text-max-width">{{ node.professione }}</span>
            </div>
          </div>
        </div>
      }
    </div>
  }

</div>
